import React from 'react';

import { FormPageActionProps } from '../formPageTypes';

import BorderFormPageHeader from './BorderFormPageHeader';
import ContainedFormPageHeader from './ContainedFormPageHeader';
import FormPageHeaderBase from './FormPageHeaderBase';

export const FormPageAction: React.FC<FormPageActionProps> = ({
  headerVariant,
  ...otherProps
}) => {
  const getHeaderComponent = () => {
    if (headerVariant === 'bottomBorder')
      return <BorderFormPageHeader borderPosition="bottom" {...otherProps} />;

    if (headerVariant === 'topBorder')
      return <BorderFormPageHeader borderPosition="top" {...otherProps} />;

    if (headerVariant === 'contained')
      return <ContainedFormPageHeader {...otherProps} />;
    return <FormPageHeaderBase {...otherProps} />;
  };
  return <>{getHeaderComponent()}</>;
};
